export default __webpack_public_path__ + "static/media/1_high_voltage.2e234a0b.png";